import { validRequired } from '@/common/elementValid.js';
let filterTaskFlowFlag = (array, type) => {
	let flag = false
	let val = array.filter((item => {
		return item.type == type
	}))
	if(val.length > 0 && val[0].taskFlowFlag) {
		flag = true
	} else {
		flag = false
	}
	return flag
}
let serviceConfirmation = ({ obj, userSearch, arr }) => {
	let infoList = obj.typeList.map(({ type }) => type);
	let totalNum = {};
	obj.typeList.forEach(item => {
		totalNum[item.type] = item.totalNum;
	});
	let isShow = id => {
		if (infoList && infoList.length !== 0) {
			return infoList.some(item => item == id);
		}
		return false;
	};

	let groups = {
		customerInfo: {
			data: '公司信息',
			formType: 'sky-line',
			displayWith() {
				return true;
			},
		},
		customerName: {
			label: '公司名称',
			formType: 'sky-text',
			value: obj.customerName,
			displayWith() {
				return true;
			},
		},
		industryType: {
			label: '公司行业',
			formType: 'sky-text',
			value: `${obj.foreignFirstIndustryName || ''} ${obj.foreignSecondIndustryName || ''}`,
			displayWith() {
				return true;
			},
		},
		agentName: {
			label: '归属渠道商',
			formType: 'sky-text',
			value: obj.agentName,
			displayWith() {
				if (obj.agentName) {
					return true;
				} else {
					return false;
				}
			},
		},
		seller: {
			label: '渠道商经理',
			formType: 'sky-text',
			value: obj.seller,
			displayWith() {
				if (obj.agentName) {
					return true;
				} else {
					return false;
				}
			},
		},
		linkman: {
			label: '联系人',
			formType: 'sky-text',
			value: `${obj.name || '-'} ${obj.mobile || '-'}`,
			displayWith() {
				return true;
			},
		},
		adminName: {
			label: '管理员名称',
			formType: 'sky-input',
			value: obj.adminName,
			rules: [validRequired('此项必填')],
			displayWith() {
				return obj.orderType == 1;
			},
		},
		adminMobile: {
			label: '管理员手机号',
			formType: 'sky-input',
			value: obj.adminMobile,
			rules: [validRequired('此项必填')],
			displayWith() {
				return obj.orderType == 1;
			},
		},
		adminPosition: {
			label: '管理员职位',
			formType: 'sky-input',
			value: obj.adminPosition,
			rules: [validRequired('此项必填')],
			displayWith() {
				return obj.orderType == 1;
			},
		},

		adminEmail: {
			label: '管理员邮箱',
			formType: 'sky-input',
			value: obj.adminEmail,
			rules: [validRequired('此项必填')],
			displayWith() {
				return obj.orderType == 1;
			},
		},

		infoList: {
			label: '服务内容',
			formType: 'sky-checkbox',
			disabled: true,
			options: obj.typeList,
			props: {
				label: 'typeName',
				value: 'type',
			},
			multiple: true,
			value: infoList,
			displayWith() {
				return true;
			},
		},
		siteLanguage: {
			data: '网站建设小语种',
			formType: 'sky-line',
			displayWith(val) {
				return val.infoList.value.includes(13);
			},
		},
		siteLanguageFlowId: {
			label: '任务关联',
			formType: 'sky-select',
			options: arr[1],
			props: {
				label: 'name',
				value: 'id',
			},
			value: obj.siteLanguageFlowId,
			displayWith(val) {
				return val.infoList.value.includes(13) && filterTaskFlowFlag(obj.typeList, 13);
			},
		},
		system: {
			data: '系统',
			formType: 'sky-line',
			displayWith() {
				return isShow(0);
			},
		},
		expirationRate: {
			label: '系统时长',
			formType: 'sky-progress',
			startDate: obj.formatUpLineDate || '-',
			endDate: obj.formatExpirationDate || '-',
			attribute: {
				'stroke-width': 16,
				'text-inside': true,
			},
			value: obj.expirationRate || 0,
		},
		accountNumber: {
			label: '账号数量',
			formType: 'sky-text',
			value: `原始${obj.systemFunctionNum || 0} 充入${totalNum['0']} 实际生效${
				(obj.systemFunctionNum || 0) + totalNum['0']
			}`,
			displayWith() {
				return isShow(0);
			},
		},
		systemFlowId: {
			label: '任务关联',
			formType: 'sky-select',
			options: arr[0],
			props: {
				label: 'name',
				value: 'id',
			},
			value: obj.systemFlowId,
			displayWith() {
				return isShow(0) && filterTaskFlowFlag(obj.typeList, 0);
			},
		},
		systemLeaderId: {
			label: '负责人',
			type: 'custom',
			formType: userSearch,
			value: obj.systemLeaderId,
			displayWith() {
				return isShow(0);
			},
		},
		website: {
			data: '网站建设',
			formType: 'sky-line',
			displayWith() {
				return isShow(1);
			},
		},
		languageNumber: {
			label: '语种数量',
			formType: 'sky-text',
			value: `原始${obj.siteFunctionNum || 0} 充入${totalNum['1']} 实际生效${
				(obj.siteFunctionNum || 0) + totalNum['1']
			}`,
			displayWith() {
				return isShow(1);
			},
		},
		siteFlowId: {
			label: '任务关联',
			formType: 'sky-select',
			options: arr[1],
			props: {
				label: 'name',
				value: 'id',
			},
			value: obj.siteFlowId,
			rules: [validRequired('此项必填', 'change')],
			displayWith() {
				return isShow(1) && filterTaskFlowFlag(obj.typeList, 1);
			},
		},
		siteLeaderId: {
			label: '负责人',
			type: 'custom',
			formType: userSearch,
			value: obj.siteLeaderId,
			rules: [validRequired('此项必填', 'change')],
			displayWith() {
				return isShow(1);
			},
		},
		google: {
			data: 'Goolge推广',
			formType: 'sky-line',
			displayWith() {
				return isShow(3);
			},
		},
		googleCidAccountVal: {
			label: 'CID',
			formType: 'sky-input',
			placeholder: '非必填',
			value: obj.googleCidAccountVal,
			displayWith() {
				return isShow(3);
			},
		},
		googleFlowId: {
			label: '任务关联',
			formType: 'sky-select',
			options: arr[3],
			props: {
				label: 'name',
				value: 'id',
			},
			value: obj.googleFlowId,
			rules: [validRequired('此项必填', 'change')],
			displayWith() {
				return isShow(3) && filterTaskFlowFlag(obj.typeList, 3);
			},
		},
		googleLeaderId: {
			label: '负责人',
			type: 'custom',
			formType: userSearch,
			value: obj.googleLeaderId,
			rules: [validRequired('此项必填', 'change')],
			displayWith() {
				return isShow(3);
			},
		},
		// socialMedia: {
		// 	data: '社媒建设',
		// 	formType: 'sky-line',
		// 	displayWith() {
		// 		return isShow(2);
		// 	},
		// },
		// platfromNumber: {
		// 	label: '平台数量',
		// 	formType: 'sky-text',
		// 	value: `原始${obj.mediaFunctionNum || 0} 充入${totalNum['2']} 实际生效${
		// 		(obj.mediaFunctionNum || 0) + totalNum['2']
		// 	}`,
		// 	displayWith() {
		// 		return isShow(2);
		// 	},
		// },
		// mediaFlowId: {
		// 	label: '任务关联',
		// 	formType: 'sky-select',
		// 	options: arr[2],
		// 	props: {
		// 		label: 'name',
		// 		value: 'id',
		// 	},
		// 	value: obj.mediaFlowId,
		// 	rules: [validRequired('此项必填', 'change')],
		// 	displayWith() {
		// 		return isShow(2);
		// 	},
		// },
		// mediaLeaderId: {
		// 	label: '负责人',
		// 	type: 'custom',
		// 	formType: userSearch,
		// 	value: obj.mediaLeaderId,
		// 	rules: [validRequired('此项必填', 'change')],
		// 	displayWith() {
		// 		return isShow(2);
		// 	},
		// },
		opration: {
			data: '社媒运营',
			formType: 'sky-line',
			displayWith() {
				return isShow(6);
			},
		},
		// subject: {
		// 	label: '社媒主体',
		// 	formType: 'sky-input',
		// 	placeholder: '请输入',
		// 	value: obj.subject,
		// 	rules: [validRequired('此项必填')],
		// 	displayWith() {
		// 		return isShow(6);
		// 	},
		// },
		taskCount: {
			label: '单月应发',
			formType: 'sky-input',
			inputType: 'number',
			placeholder: '必填',
			value: obj.taskCount,
			rules: [validRequired('此项必填')],
			displayWith() {
				return isShow(6);
			},
		},
		mediaOperationFlowId: {
			label: '任务关联',
			formType: 'sky-select',
			options: arr[6],
			props: {
				label: 'name',
				value: 'id',
			},
			value: obj.mediaOperationFlowId,
			rules: [validRequired('此项必填', 'change')],
			displayWith() {
				return isShow(6) && filterTaskFlowFlag(obj.typeList, 6);
			},
		},
		mediaOperationLeaderId: {
			label: '负责人',
			type: 'custom',
			formType: userSearch,
			value: obj.mediaOperationLeaderId,
			rules: [validRequired('此项必填', 'change')],
			displayWith() {
				return isShow(6);
			},
		},
		FaceBook: {
			data: 'FB推广',
			formType: 'sky-line',
			displayWith() {
				return isShow(7);
			},
		},
		facebookCidAccountVal: {
			label: 'FBID',
			formType: 'sky-input',
			placeholder: '非必填',
			value: obj.facebookCidAccountVal,
			displayWith() {
				return isShow(7);
			},
		},
		facebookLeaderId: {
			label: '负责人',
			type: 'custom',
			formType: userSearch,
			value: obj.facebookLeaderId,
			rules: [validRequired('此项必填', 'change')],
			displayWith() {
				return isShow(7);
			},
		},
		facebookFlowId: {
			label: '任务关联',
			formType: 'sky-select',
			options: arr[7],
			props: {
				label: 'name',
				value: 'id',
			},
			value: obj.facebookFlowId,
			rules: [validRequired('此项必填', 'change')],
			displayWith() {
				return isShow(7) && filterTaskFlowFlag(obj.typeList, 7);
			},
		},
		video: {
			data: '视频拍摄',
			formType: 'sky-line',
			displayWith() {
				return isShow(4);
			},
		},
		videoFlowId: {
			label: '任务关联',
			formType: 'sky-select',
			options: arr[4],
			props: {
				label: 'name',
				value: 'id',
			},
			value: obj.videoFlowId,
			rules: [validRequired('此项必填', 'change')],
			displayWith() {
				return isShow(4) && filterTaskFlowFlag(obj.typeList, 4);
			},
		},
		videoLeaderId: {
			label: '负责人',
			type: 'custom',
			formType: userSearch,
			value: obj.videoLeaderId,
			rules: [validRequired('此项必填', 'change')],
			displayWith() {
				return isShow(4);
			},
		},
		ZNSB: {
			data: '访客识别',
			formType: 'sky-line',
			displayWith() {
				return isShow(10);
			},
		},
		visitorsToIdentifyFlowId: {
			label: '任务关联',
			formType: 'sky-select',
			options: arr[8],
			props: {
				label: 'name',
				value: 'id',
			},
			value: obj.visitorsToIdentifyFlowId,
			rules: [validRequired('此项必填', 'change')],
			displayWith() {
				return isShow(10) && filterTaskFlowFlag(obj.typeList, 10);
			},
		},
		visitorsToIdentifyLeaderId: {
			label: '负责人',
			type: 'custom',
			formType: userSearch,
			value: obj.visitorsToIdentifyLeaderId,
			rules: [validRequired('此项必填', 'change')],
			displayWith() {
				return isShow(10);
			},
		},
		SEO: {
			data: 'SEO排名监控',
			formType: 'sky-line',
			displayWith() {
				return isShow(5);
			},
		},
		seoFlowId: {
			label: '任务关联',
			formType: 'sky-select',
			options: arr[5],
			props: {
				label: 'name',
				value: 'id',
			},
			value: obj.seoFlowId,
			rules: [validRequired('此项必填', 'change')],
			displayWith() {
				return isShow(5) && filterTaskFlowFlag(obj.typeList, 5);
			},
		},
		seoLeaderId: {
			label: '负责人',
			type: 'custom',
			formType: userSearch,
			value: obj.seoLeaderId,
			rules: [validRequired('此项必填', 'change')],
			displayWith() {
				return isShow(5);
			},
		},
		WhatsApp: {
			data: 'WhatsApp服务',
			formType: 'sky-line',
			displayWith() {
				return isShow(21);
			},
		},
		whatsAppFlowId: {
			label: '任务关联',
			formType: 'sky-select',
			options: arr[9],
			props: {
				label: 'name',
				value: 'id',
			},
			value: obj.whatsAppFlowId,
			rules: [validRequired('此项必填', 'change')],
			displayWith() {
				return isShow(21) && filterTaskFlowFlag(obj.typeList, 21);
			},
		},
		Yandex: {
			data: 'Yandex推广',
			formType: 'sky-line',
			displayWith() {
				return isShow(22);
			},
		},
		yandexCidAccountVal: {
			label: 'CID',
			formType: 'sky-input',
			placeholder: '非必填',
			value: obj.yandexCidAccountVal,
			displayWith() {
				return isShow(22);
			},
		},
		yandexFlowId: {
			label: '任务关联',
			formType: 'sky-select',
			options: arr[10],
			props: {
				label: 'name',
				value: 'id',
			},
			value: obj.yandexFlowId,
			rules: [validRequired('此项必填', 'change')],
			displayWith() {
				return isShow(22) && filterTaskFlowFlag(obj.typeList, 22);
			},
		},
		yandexLeaderId: {
			label: '负责人',
			type: 'custom',
			formType: userSearch,
			value: obj.yandexLeaderId,
			rules: [validRequired('此项必填', 'change')],
			displayWith() {
				return isShow(22);
			},
		},
		LinkedIn: {
			data: 'LinkedIn推广',
			formType: 'sky-line',
			displayWith() {
				return isShow(23);
			},
		},
		linkedInCidAccountVal: {
			label: 'CID',
			formType: 'sky-input',
			placeholder: '非必填',
			value: obj.linkedInCidAccountVal,
			displayWith() {
				return isShow(23);
			},
		},
		linkedInFlowId: {
			label: '任务关联',
			formType: 'sky-select',
			options: arr[11],
			props: {
				label: 'name',
				value: 'id',
			},
			value: obj.linkedInFlowId,
			rules: [validRequired('此项必填', 'change')],
			displayWith() {
				return isShow(23) && filterTaskFlowFlag(obj.typeList, 23);
			},
		},
		linkedInLeaderId: {
			label: '负责人',
			type: 'custom',
			formType: userSearch,
			value: obj.linkedInLeaderId,
			rules: [validRequired('此项必填', 'change')],
			displayWith() {
				return isShow(23);
			},
		},
	};
	return groups;
};

export default serviceConfirmation;
